import { Autocomplete, TextField } from 'components/mui';
import { useState, useEffect } from 'react';

const AddrSelector = ({ addresses, setAddressID }) => {
	const [value, setValue] = useState({});

	const onChange = (e, values) => {
		setValue(values);
		setAddressID(values.Id);
	};
	useEffect(() => {
		setValue({});
	}, [addresses]);

	return (
		<>
			{addresses && (
				<Autocomplete
					value={value}
					options={addresses}
					getOptionLabel={(option) =>
						option.Title ? option.Title : ''
					}
					isOptionEqualToValue={(option, value) =>
						option.value === value.value
					}
					onChange={onChange}
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							label="Addresses"
							InputLabelProps={{ shrink: true }}
						/>
					)}
				/>
			)}
		</>
	);
};

export default AddrSelector;
